<template>
  <div :class="$vssWidth > 1270 ? 'content' : 'content2'">
    <div class="etapas">
      <input type="submit" class="btn-inativo" value="1" />
      <div class="linha"></div>
      <input type="submit" class="btn-ativo" value="2" />
      <div class="linha"></div>
      <input type="submit" class="btn-inativo" value="3" />
    </div>

    <div class="etapas-titulo">
      <p class="p-inativo">Etapa 1:<br />login ou cadastro</p>
      <div class="linha-espaco"></div>
      <p class="p-ativo">Etapa 2:<br />pagamento</p>
      <div class="linha-espaco"></div>
      <p class="p-inativo">Etapa 3:<br />concluído</p>
    </div>

    <div :class="$vssWidth > 1500 ? 'pagamento2' : 'pagamento'">
      <p class="titulo">ESCOLHA A FORMA DE PAGAMENTO</p>
      <div class="form">
        <div class="forma-pgto">
          <div
            class="credito ativo"
            v-if="$store.state.finalizarCompra.cartaoCredito === true"
          >
            <span><i class="far fa-credit-card icone"></i></span>
            <span>Cartão de Crédito</span>
          </div>
          <div v-else class="credito" @click="opcaoCartaoCredito()">
            <span><i class="far fa-credit-card icone"></i></span>
            <span>Cartão de Crédito</span>
          </div>
          <!-- <div class="debito ativo" v-if="$store.state.finalizarCompra.cartaoDebito === true">
            <span><i class="far fa-credit-card icone"></i></span>
            <span>Cartão de Débito</span>
          </div>
          <div v-else class="debito" @click="opcaoCartaoDebito()">
            <span><i class="far fa-credit-card icone"></i></span>
            <span>Cartão de Débito</span>
          </div> -->
          <div
            v-if="$store.state.finalizarCompra.picPay === true"
            class="picpay ativo"
            @click="opcaoPicPay()"
          >
            <span><i class="fas fa-qrcode icone"></i></span>
            <span>PicPay</span>
          </div>
          <div v-else class="picpay" @click="opcaoPicPay()">
            <span><i class="fas fa-qrcode icone"></i></span>
            <span>PicPay</span>
          </div>
        </div>

        <transition mode="out-in">
          <div
            class="formulario-pgto"
            v-if="$store.state.finalizarCompra.cartaoCredito === true"
          >
            <form @submit.prevent="getCardToken">
              <div
                :class="$vssWidth > 1500 ? 'formulario-ok2' : 'formulario-ok'"
              >
                <div style="position: relative" class="form-left">
                  <span>NÚMERO DO CARTÃO</span>
                  <input
                    v-mask="'#### #### #### ####'"
                    v-model="cartaoCreditoModel.numeroCartao"
                    type="text"
                    name="nome"
                    placeholder="0000 0000 0000 0000"
                    autofocus
                    required
                  />
                  <img
                    width="30px"
                    v-bind:src="
                      'https://raw.githubusercontent.com/CarlosCastroWolf/assetsilha/master/' +
                      getCardTypeCredito +
                      '.png'
                    "
                    v-if="getCardTypeCredito"
                    v-bind:key="getCardTypeCredito"
                    class="logo-cartao"
                  />
                </div>
                <div class="validade">
                  <span>VALIDADE</span>
                  <select
                    placeholder="mês"
                    v-model="cartaoCreditoModel.mesVencimento"
                    required
                  >
                    <option
                      v-for="mes in listaMesVencimento"
                      :key="mes"
                      :value="mes"
                    >
                      {{ mes }}
                    </option>
                  </select>
                  <select
                    class="select-ano"
                    placeholder="ano"
                    v-model="cartaoCreditoModel.anoVencimento"
                    required
                  >
                    <option
                      v-for="ano in listaAnoVencimento"
                      :key="ano"
                      :value="ano"
                    >
                      {{ ano }}
                    </option>
                  </select>
                </div>
              </div>

              <div
                :class="$vssWidth > 1500 ? 'formulario-ok2' : 'formulario-ok'"
              >
                <div class="form-left">
                  <span>NOME DO TITULAR</span>
                  <input
                    v-model="cartaoCreditoModel.nomeCartao"
                    type="text"
                    name="nome"
                    placeholder="Nome impresso no cartão"
                    required
                  />
                  <span class="dica"
                    >Digite o nome exatamente como está impresso no cartão</span
                  >
                </div>
                <div class="form-right">
                  <span>CÓDIGO DE SEGURANÇA</span>
                  <input
                    class="select-codigo"
                    v-model="cartaoCreditoModel.codSeguranca"
                    type="number"
                    name="cvv"
                    placeholder="CVV"
                    required
                  />
                </div>
              </div>

              <div
                :class="$vssWidth > 1500 ? 'formulario-ok2' : 'formulario-ok'"
              >
                <div class="form-left">
                  <span>CPF DO TITULAR DO CARTÃO</span>
                  <input
                    class="select-cpf"
                    v-model="cartaoCreditoModel.cpf"
                    v-mask="'###.###.###-##'"
                    type="text"
                    name="cpf"
                    placeholder="000.000.000-00"
                    required
                  />
                  <span class="dica"
                    >O CPF carregado é o que consta no seu cadastro</span
                  >
                </div>
              </div>

              <div
                :class="$vssWidth > 1500 ? 'formulario-ok2' : 'formulario-ok'"
              >
                <div class="form-left">
                  <span>Bandeiras aceitas no crédito:</span>
                  <img src="https://firebasestorage.googleapis.com/v0/b/loja-ilha-teste.appspot.com/o/assets%2Fcartoes-credito.webp?alt=media&token=a2ac72b0-74f4-43c0-b5a3-816006db4118" />
                </div>
              </div>

              <button type="submit" :disabled="botaoClicado" class="bt-login">
                CONFIRMAR PAGAMENTO
              </button>
            </form>
          </div>
        </transition>

        <transition mode="out-in">
          <div
            class="formulario-pgto"
            v-if="$store.state.finalizarCompra.cartaoDebito === true"
          >
            <form @submit.prevent="getCardToken">
              <div
                :class="$vssWidth > 1500 ? 'formulario-ok2' : 'formulario-ok'"
              >
                <div style="position: relative" class="form-left">
                  <span>NÚMERO DO CARTÃO</span>
                  <input
                    v-mask="'#### #### #### ####'"
                    v-model="cartaoDebitoModel.numeroCartao"
                    type="text"
                    name="nome"
                    placeholder="0000 0000 0000 0000"
                    autofocus
                    required
                  />
                  <img
                    width="30px"
                    v-bind:src="
                      'https://raw.githubusercontent.com/CarlosCastroWolf/assetsilha/master/' +
                      getCardTypeDebito +
                      '.png'
                    "
                    v-if="getCardTypeDebito"
                    v-bind:key="getCardTypeDebito"
                    class="logo-cartao"
                  />
                </div>
                <div class="validade">
                  <span>VALIDADE</span>
                  <select
                    placeholder="mês"
                    v-model="cartaoDebitoModel.mesVencimento"
                    required
                  >
                    <option
                      v-for="mes in listaMesVencimento"
                      :key="mes"
                      :value="mes"
                    >
                      {{ mes }}
                    </option>
                  </select>
                  <select
                    class="select-ano"
                    placeholder="ano"
                    v-model="cartaoDebitoModel.anoVencimento"
                    required
                  >
                    <option
                      v-for="ano in listaAnoVencimento"
                      :key="ano"
                      :value="ano"
                    >
                      {{ ano }}
                    </option>
                  </select>
                </div>
              </div>

              <div
                :class="$vssWidth > 1500 ? 'formulario-ok2' : 'formulario-ok'"
              >
                <div class="form-left">
                  <span>NOME DO TITULAR</span>
                  <input
                    v-model="cartaoDebitoModel.nomeCartao"
                    type="text"
                    name="nome"
                    placeholder="Nome impresso no cartão"
                    required
                  />
                  <span class="dica"
                    >Digite o nome exatamente como está impresso no cartão</span
                  >
                </div>
                <div class="form-right">
                  <span>CÓDIGO DE SEGURANÇA</span>
                  <input
                    class="select-codigo"
                    v-model="cartaoDebitoModel.codSeguranca"
                    type="number"
                    name="cvv"
                    placeholder="CVV"
                    required
                  />
                </div>
              </div>

              <div
                :class="$vssWidth > 1500 ? 'formulario-ok2' : 'formulario-ok'"
              >
                <div class="form-left">
                  <span>CPF DO TITULAR DO CARTÃO</span>
                  <input
                    class="select-cpf"
                    v-model="cartaoDebitoModel.cpf"
                    v-mask="'###.###.###-##'"
                    type="text"
                    name="cpf"
                    placeholder="000.000.000-00"
                    required
                  />
                  <span class="dica"
                    >O CPF carregado é o que consta no seu cadastro</span
                  >
                </div>
              </div>

              <div
                :class="$vssWidth > 1500 ? 'formulario-ok2' : 'formulario-ok'"
              >
                <div class="form-left">
                  <span>Bandeiras aceitas no débito:</span>
                  <img src="https://firebasestorage.googleapis.com/v0/b/loja-ilha-teste.appspot.com/o/assets%2Fcartoes-debito.webp?alt=media&token=d7f48e61-20ab-4ebe-848c-470fdbc0ebc4" />
                </div>
              </div>

              <button type="submit" :disabled="botaoClicado" class="bt-login">
                CONFIRMAR PAGAMENTO
              </button>
            </form>
          </div>
        </transition>

        <transition mode="out-in">
          <div
            class="formulario-pgto"
            v-if="$store.state.finalizarCompra.picPay === true"
          >
            <p class="picpay-mensagem">
              Utilize o QR Code ou o link para realizar o pagamento pelo PicPay
            </p>
            <div class="picpay-div2">
              <i class="far fa-hourglass icone-ampulheta"></i>
              <p class="picpay-mensagem2">
                Sua compra é finalizada após confirmação do PicPay.<br />
                Você será avisado por e-mail assim que a transação for
                concluída.
              </p>
            </div>
            <div class="formulario-ok">
              <div
                v-if="
                  $store.state.finalizarCompra.qrCodePicPay && $vssWidth > 960
                "
                class="picpay-div"
              >
                <img v-bind:src="$store.state.finalizarCompra.qrCodePicPay" />
              </div>
              <div
                @click="picPayAcessarUrl()"
                class="picpay-div picpay-background"
              >
                <img src="https://firebasestorage.googleapis.com/v0/b/loja-ilha-teste.appspot.com/o/assets%2Flogo_picpay.webp?alt=media&token=f34b4a97-df6f-441d-9528-d9b853acbdaf" /><br />
              </div>
              <p @click="picPayAcessarUrl()" class="picpay-link">
                {{ $store.state.finalizarCompra.urlPicPay.substring(0, 22) }}
              </p>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { db, Timestamp } from "@/firebase.js";
import axios from "axios";
import { mapActions } from "vuex";
import VueScreenSize from "vue-screen-size";
import CarrinhoFooter from "@/views/CarrinhoFooter";
import cupom from "../methods/Cupom";

export default {
  ...cupom,
  name: "Pagamento",
  mixins: [VueScreenSize.VueScreenSizeMixin],
  props: ["id"],
  components: {
    db,
    CarrinhoFooter,
  },
  data: function () {
    return {
      botaoClicado: false,
      saindoPagamentoConcluido: false,
      htmlPromocoes: "",
      produtosCarrinho: null,
      imageBytes: null,
      enderecoIp: null,
      sessionId: null,
      dataExpiracao: null,
      listaAnoVencimento: [
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
        "2031",
        "2032",
        "2033",
        "2034",
        "2035",
        "2036",
        "2037",
        "2038",
        "2039",
        "2040",
      ],
      listaMesVencimento: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      accessToken: null,
      cartaoCreditoModel: {
        nomeCartao: null,
        mesVencimento: null,
        anoVencimento: null,
        codSeguranca: null,
        cpf: this.$store.state.usuario.usuario.Cpf,
        numeroCartao: " ",
      },
      cartaoDebitoModel: {
        nomeCartao: null,
        mesVencimento: null,
        anoVencimento: null,
        codSeguranca: null,
        cpf: this.$store.state.usuario.usuario.Cpf,
        numeroCartao: " ",
      },
    };
  },
  created() {
    this.getAccessToken();
    this.defineFinalizarCompra();
    this.getDataExpiracao();
    this.getTotal();
    this.getCarrinho();
    this.carregarFinalizacaoCompraResponsivo();
    this.pegarIp();
  },
  destroyed() {
    this.limparFinalizarCompraMenu();
    this.removerOpcoesPagamentoSelecionadas();
  },
  computed: {
    getCardTypeCredito() {
      let number =
        this.cartaoCreditoModel.numeroCartao != null
          ? this.cartaoCreditoModel.numeroCartao.replace(/\s/g, "")
          : "";
      let re = new RegExp("^4");
      if (number.match(re) != null) return "Visa";

      re = new RegExp("^(34|37)");
      if (number.match(re) != null) return "Amex";

      re = new RegExp("^5[1-5]");
      if (number.match(re) != null) return "Mastercard";

      re = new RegExp("^6011");
      if (number.match(re) != null) return "Discover";

      re = new RegExp("^9792");
      if (number.match(re) != null) return "Troy";

      re =
        /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/;
      if (re.test(number)) return "Elo";

      re = /^(606282\d{10}(\d{3})?)|(3841\d{15})$/;
      if (re.test(number)) return "Hipercard";

      return null;
    },
    getCardTypeDebito() {
      let number =
        this.cartaoDebitoModel.numeroCartao != null
          ? this.cartaoDebitoModel.numeroCartao.replace(/\s/g, "")
          : "";
      let re = new RegExp("^4");
      if (number.match(re) != null) return "Visa";

      re = new RegExp("^(34|37)");
      if (number.match(re) != null) return "Amex";

      re = new RegExp("^5[1-5]");
      if (number.match(re) != null) return "Mastercard";

      re = new RegExp("^6011");
      if (number.match(re) != null) return "Discover";

      re = new RegExp("^9792");
      if (number.match(re) != null) return "Troy";

      re =
        /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/;
      if (re.test(number)) return "Elo";

      re = /^(606282\d{10}(\d{3})?)|(3841\d{15})$/;
      if (re.test(number)) return "Hipercard";

      return null;
    },
  },
  methods: {
    ...mapActions("finalizarCompra", [
      "cartaoCredito",
      "cartaoDebito",
      "picPay",
      "idPedidoAtual",
      "removeOpcoesPagamento",
      "qrCodePicPay",
      "urlPicPay",
      "removerConfiguracoes",
    ]),
    ...mapActions("menu", ["finalizacaoPedido", "finalizacaoCompraResponsivo"]),
    ...mapActions("carrinho", [
      "limparCarrinho",
      "pagamentoConcluido",
      "total",
      "destroiCupom",
    ]),
    ...mapActions("usuario", ["usuarioAtual", "loginCpf"]),
    ...mapActions("configuracoes", ["loading"]),
    cancelarPedidoAtualPicPay() {
      if (
        this.$store.state.finalizarCompra.qrCodePicPay != null ||
        this.$store.state.finalizarCompra.urlPicPay
      ) {
        axios({
          method: "post",
          url: "https://us-central1-loja-ilha-teste.cloudfunctions.net/cancelamentoPicPay",
          data: {
            referenceId: this.$store.state.finalizarCompra.idPedido,
          },
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    limparLoginCpf() {
      this.loginCpf(false);
    },
    getTotal() {
      db.collection("Carrinho")
        .doc(this.$store.state.carrinho.idCarrinho)
        .onSnapshot((doc) => {
          if (doc.exists) {
            var totalAtual = 0;
            for (var i in doc.data().ItensCarrinho) {
              totalAtual =
                totalAtual +
                doc.data().ItensCarrinho[i].ValorUnitario *
                  doc.data().ItensCarrinho[i].Quantidade;
            }
            this.total(totalAtual - this.$store.state.carrinho.cupomDesconto);
          }
        });
    },
    getCarrinho() {
      db.collection("Carrinho")
        .doc(this.$store.state.carrinho.idCarrinho)
        .get()
        .then((doc) => {
          this.produtosCarrinho = doc.data().ItensCarrinho;
          var totalAtual = 0;
          for (var i in doc.data().ItensCarrinho) {
            totalAtual =
              totalAtual +
              doc.data().ItensCarrinho[i].ValorUnitario *
                doc.data().ItensCarrinho[i].Quantidade;
          }
          this.total(totalAtual - this.$store.state.carrinho.cupomDesconto);
        });
    },
    limparFinalizarCompraMenu() {
      this.finalizacaoPedido(false);
    },
    carregarFinalizacaoCompraResponsivo() {
      this.finalizacaoCompraResponsivo(true);
    },
    picPayAcessarUrl() {
      window.open(this.$store.state.finalizarCompra.urlPicPay, "_blank");
    },
    retornaMensagemAntifraude(valor) {
      switch (valor) {
        case "200":
        case "250":
        case "0700":
        case "2000":
        case "480":
        case "481":
          return "Infelizmente sua transação foi negada por regra de segurança do sistema de Antifraude da sua operadora de cartão";
        case "0150":
          return "Ocorreu um problema com o valor do carrinho de compras";
        case "0902":
        case "101":
        case "102":
          return "O sistema antifraude detectou que suas informações estão incompletas, tente atualizar o seu cadastro";
        case "231":
        case "0400":
        case "202":
          return "Dados do cartão de crédito preenchidos incorretamente";
        case "400":
        case "0330":
        case "0500":
        case "0600":
        case "1300":
        case "0800":
          return "O sistema antifraude da sua operadora de cartão de crédito não autorizou esta transação";
        case "234":
        case "0901":
        case "0000":
        case "0903":
        case "150":
        case "151":
        case "121":
        case "500":
          return "O sistema antifraude da sua operadora de cartão está fora do ar";
      }
    },
    retornaMensagemErro400(valor) {
      switch (valor) {
        case "PAYMENTS-015":
          return "Por favor, entre em contato com o emissor do seu cartão";
        case "PAYMENTS-019":
          return "Data de emissão do cartão inválida";
        case "PAYMENTS-020":
          return "Data de vencimento inválida";
        case "PAYMENTS-025":
          return "Autenticação inválida";
        case "PAYMENTS-026":
          return "Autorização inválida";
        case "PAYMENTS-029":
          return "Pré-autorização inválida";
        case "PAYMENTS-044":
          return "Erro de formato";
        case "PAYMENTS-050":
          return "Por favor, entre em contato com o emissor do seu cartão";
        case "PAYMENTS-051":
          return "Resposta parametrizada nnegativa";
        case "PAYMENTS-054":
          return "Pendente de confirmação";
        case "PAYMENTS-055":
          return "Transação cancelada";
        case "PAYMENTS-056":
          return "Transação não permitida neste ciclo";
        case "PAYMENTS-058":
          return "Transação estornada";
        case "PAYMENTS-060":
          return "Cartão obrigatório na transação";
        case "PAYMENTS-061":
          return "Rejeição genérica";
        case "PAYMENTS-066":
          return "Forma de pagamento inválido";
        case "PAYMENTS-068":
          return "Dígito do cartão inválido";
        case "PAYMENTS-069":
          return "Transação repetida";
        case "PAYMENTS-070":
          return "Número do cartão não confere";
        case "PAYMENTS-072":
          return "Transação não cancelável";
        case "PAYMENTS-073":
          return "Transação já cancelada";
        case "PAYMENTS-078":
          return "Dados inválidos no cancelamento";
        case "PAYMENTS-079":
          return "Valor do cancelamento inválido";
        case "PAYMENTS-080":
          return "Cartão inválido";
        case "PAYMENTS-081":
          return "Data limite excedida";
        case "PAYMENTS-082":
          return "Cancelamento inválido";
        case "PAYMENTS-083":
          return "Para o cartão informado, por favor utilize o pagamento via Cartão de Débito";
        case "PAYMENTS-084":
          return "Para o cartão informado, por favor utilize o pagamento via Cartão de Crédito";
        case "PAYMENTS-085":
          return "Transação já efetuada";
        case "PAYMENTS-090":
          return "Transação não autorizada pelo cartão";
        case "PAYMENTS-091":
          return "Pagamento fora do prazo permitido";
        case "PAYMENTS-093":
          return "Autorização já encontra-se em processamento";
        case "PAYMENTS-094":
          return "Autorização a confirmar recebimento";
        case "PAYMENTS-098":
          return "Cliente não cadastrado";
        case "PAYMENTS-117":
          return "Por favor, entre em contato com o emissor do seu cartão";
        case "PAYMENTS-118":
          return "Cartão inválido ou produto não habilitado";
        case "PAYMENTS-999":
          return "Transação não processada";
      }
    },
    retornaMensagemErro402(valor) {
      switch (valor) {
        case "PAYMENTS-001":
          return "Valor não informado";
        case "PAYMENTS-002":
          return "Cartão informado é inválido";
        case "PAYMENTS-003":
          return "Cartão informado está vencido";
        case "PAYMENTS-004":
          return "Parâmetro inválido";
        case "PAYMENTS-005":
          return "Código de segurança informado é inválido";
        case "PAYMENTS-006":
          return "Bandeira do cartão é inválida";
        case "PAYMENTS-007":
          return "Operação não permitida";
        case "PAYMENTS-008":
          return "Dados inválidos";
        case "PAYMENTS-022":
          return "Código de moeda inválido";
        case "PAYMENTS-023":
          return "Bandeira do cartão não é aceita em nosso sistema";
        case "PAYMENTS-030":
          return "Erro na autenticação do usuário";
        case "PAYMENTS-032":
          return "Transação negada pelo emissor do seu cartão";
        case "PAYMENTS-033":
          return "Entre em contato com a operadora do seu cartão";
        case "PAYMENTS-034":
          return "Solicitação não autorizada";
        case "PAYMENTS-037":
          return "Transação já em andamento";
        case "PAYMENTS-038":
          return "Transação inválida";
        case "PAYMENTS-039":
          return "Valor da transação inválido";
        case "PAYMENTS-041":
          return "Transação precisa ser refeita";
        case "PAYMENTS-045":
          return "O cartão informado possui restrições";
        case "PAYMENTS-046":
          return "O cartão informado consta como extraviado em nosso sistema";
        case "PAYMENTS-047":
          return "O cartão informado consta como roubado em nosso sistema";
        case "PAYMENTS-048":
          return "O cartão informado não possui registro no emissor";
        case "PAYMENTS-049":
          return "Transação não permitida para este cartão";
        case "PAYMENTS-052":
          return "Transação duplicada e já em processamento";
        case "PAYMENTS-053":
          return "Cartão informado está bloqueado";
        case "PAYMENTS-067":
          return "Limite do cartão foi excedido";
        case "PAYMENTS-077":
          return "Número do cartão inválido";
        case "PAYMENTS-096":
          return "Crédito excedido";
        case "PAYMENTS-101":
          return "Autorizadora do cartão está offline";
        case "PAYMENTS-102":
          return "Cliente sem limite de crédito";
        case "PAYMENTS-103":
          return "Transação não autorizada pela rede autorizadora";
        case "PAYMENTS-104":
          return "Erro de integração";
        case "PAYMENTS-105":
          return "Transação não autorizada";
        case "PAYMENTS-109":
          return "Existe transação a confirmar com os seus dados";
        case "PAYMENTS-112":
          return "Documento inexistente para cancelar";
        case "PAYMENTS-113":
          return "Saldo insuficiente para concluir a transação";
        case "PAYMENTS-114":
          return "A transação excede o limite de valor de aprovação";
        case "PAYMENTS-115":
          return "A operadora do seu cartão informa que esta transação excede o limite de compras";
        case "PAYMENTS-116":
          return "Por favor entre em contato com o emissor do seu cartão";
        case "PAYMENTS-999":
          return "A operadora do seu cartão indica que o limite de compras foi excedido";
      }
    },
    getDataExpiracao() {
      var d = new Date();
      d.setMinutes(d.getMinutes() + 6);
      this.dataExpiracao = d.toISOString();
    },
    removerOpcoesPagamentoSelecionadas() {
      this.removeOpcoesPagamento();
    },
    defineFinalizarCompra() {
      this.finalizacaoPedido(true);
    },
    async defineCodigoPedido() {
      await db
        .collection("Configuracoes")
        .doc("CodigoPedido")
        .get()
        .then((doc) => {
          var numeroPedido = doc.data().CodigoPedido + 1;
          this.idPedidoAtual(numeroPedido);
        });
      await db.collection("Configuracoes").doc("CodigoPedido").set({
        CodigoPedido: this.$store.state.finalizarCompra.idPedido,
      });
      if (this.$store.state.finalizarCompra.picPay !== true) {
        await this.pegarDeviceId();
      }
    },
    getAccessToken() {
      axios({
        method: "post",
        url: "https://api.getnet.com.br/auth/oauth/v2/token",
        data: "scope=oob&grant_type=client_credentials",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          authorization:
            "Basic MWExOTQwNjItZDVmZi00ZGM0LWExODItZDBiNDE0MzY3MjcwOmVkQWw5OTROakxqcDNzbklvcFVudllUZ1k3ck5wR0ZU",
        },
      })
        .then((response) => {
          this.accessToken = response.data.access_token;
        })
        .catch((response) => {
          console.log("aqui");
        });
    },
    getCardToken() {
      this.botaoClicado = true;
      this.loading(true);
      if (this.$store.state.carrinho.idCarrinho != null) {
        axios({
          method: "post",
          url: "https://api.getnet.com.br/v1/tokens/card",
          data: {
            card_number:
              this.$store.state.finalizarCompra.cartaoCredito === true
                ? this.cartaoCreditoModel.numeroCartao.replace(/\s/g, "")
                : this.cartaoDebitoModel.numeroCartao.replace(/\s/g, ""),
            customer_id: this.$store.state.usuario.usuario.id,
          },
          headers: {
            authorization: "Bearer " + this.accessToken,
            "content-type": "application/json; charset=utf-8",
            seller_id: "5c7823bc-ddf5-444d-a806-419def45f5f3",
          },
        })
          .then((response) => {
            if (this.$store.state.finalizarCompra.cartaoCredito === true) {
              this.realizarPagamentoCredito(response.data.number_token);
            } else if (
              this.$store.state.finalizarCompra.cartaoDebito === true
            ) {
              this.realizarPagamentoDebito(response.data.number_token);
            }
          })
          .catch((error) => {
            this.loading(false);
            if (error.response.status === 402) {
              this.$fire({
                title: "Dados inválidos",
                text: "Favor verifique os dados preenchidos e tente novamente",
                type: "error",
              });
            }
          });
      } else {
        this.loading(false);
        this.$fire({
          title: "O prazo para concluir a sua compra foi expirado",
          type: "warning",
        }).then((r) => {
          this.$router.push({ name: "HomePage" });
        });
      }
    },
    async pegarDeviceId() {
      var sessionId =
        this.$store.state.usuario.usuario.id +
        this.$store.state.finalizarCompra.idPedido.toString();
      await axios({
        method: "post",
        url: "https://us-central1-loja-ilha-teste.cloudfunctions.net/deviceid",
        data: {
          sessionId: sessionId,
        },
      })
        .then((response) => {
          this.sessionId =
            this.$store.state.usuario.usuario.id +
            this.$store.state.finalizarCompra.idPedido.toString();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pegarIp() {
      fetch("https://api.ipify.org?format=json")
        .then((x) => x.json())
        .then(({ ip }) => {
          this.enderecoIp = ip;
        });
    },
    async realizarPagamentoCredito(cardToken) {
      this.cancelarPedidoAtualPicPay();
      await this.defineCodigoPedido();
      axios({
        method: "post",
        url: "https://api.getnet.com.br/v1/payments/credit",
        data: {
          seller_id: "5c7823bc-ddf5-444d-a806-419def45f5f3",
          amount: Math.round(this.$store.state.carrinho.total * 100),
          currency: "BRL",
          order: {
            order_id: this.$store.state.finalizarCompra.idPedido.toString(),
          },
          customer: {
            customer_id: this.$store.state.usuario.usuario.id,
            first_name: this.$store.state.usuario.usuario.PrimeiroNome,
            last_name: this.$store.state.usuario.usuario.UltimoNome,
            name: this.$store.state.usuario.usuario.NomeCompleto,
            email: this.$store.state.usuario.usuario.Email,
            document_type: "CPF",
            document_number: this.cartaoCreditoModel.cpf
              .replace(/\./g, "")
              .replace("-", ""),
            phone_number: this.$store.state.usuario.usuario.Telefone.replace(
              "(",
              ""
            )
              .replace(")", "")
              .replace(" ", "")
              .replace("-", ""),
            billing_address: {
              street: this.$store.state.usuario.usuario.EnderecoRua,
              number: this.$store.state.usuario.usuario.EnderecoNumero,
              complement: this.$store.state.usuario.usuario.EnderecoComplemento,
              district: this.$store.state.usuario.usuario.EnderecoBairro,
              city: this.$store.state.usuario.usuario.EnderecoCidade,
              state: this.$store.state.usuario.usuario.EnderecoUf,
              country: "Brasil",
              postal_code:
                this.$store.state.usuario.usuario.EnderecoCep.replace(
                  /\./g,
                  ""
                ).replace("-", ""),
            },
          },
          device: {
            ip_address: this.enderecoIp,
            device_id: this.sessionId,
          },
          shippings: [
            {
              first_name: this.$store.state.usuario.usuario.PrimeiroNome,
              name: this.$store.state.usuario.usuario.NomeCompleto,
              email: this.$store.state.usuario.usuario.Email,
              phone_number: this.$store.state.usuario.usuario.Telefone.replace(
                "(",
                ""
              )
                .replace(")", "")
                .replace(" ", "")
                .replace("-", ""),
              shipping_amount: 0,
              address: {
                street: this.$store.state.usuario.usuario.EnderecoRua,
                number: this.$store.state.usuario.usuario.EnderecoNumero,
                complement:
                  this.$store.state.usuario.usuario.EnderecoComplemento,
                district: this.$store.state.usuario.usuario.EnderecoBairro,
                city: this.$store.state.usuario.usuario.EnderecoCidade,
                state: this.$store.state.usuario.usuario.EnderecoUf,
                country: "Brasil",
                postal_code:
                  this.$store.state.usuario.usuario.EnderecoCep.replace(
                    /\./g,
                    ""
                  ).replace("-", ""),
              },
            },
          ],
          credit: {
            delayed: false,
            save_card_data: false,
            transaction_type: "FULL",
            number_installments: 1,
            card: {
              number_token: cardToken,
              brand: this.getCardTypeCredito,
              cardholder_name: this.cartaoCreditoModel.nomeCartao,
              security_code: this.cartaoCreditoModel.codSeguranca,
              expiration_month: this.cartaoCreditoModel.mesVencimento,
              expiration_year: this.cartaoCreditoModel.anoVencimento.substring(
                2,
                4
              ),
            },
          },
        },
        headers: {
          authorization: "Bearer " + this.accessToken,
          "content-type": "application/json; charset=utf-8",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.finalizarPagamento(
              response.data.status,
              response.data,
              "GetNet Crédito"
            );
          } else {
            this.gravarRespostasPagamentoNaoConcluido(
              response.data,
              "GetNet Crédito"
            );
          }
        })
        .catch((error) => {
          this.gravarPagamentoErro(error.response.data, "GetNet Crédito");
          this.loading(false);
          console.log(error.response);
          if (error.response.status === 400) {
            this.$fire({
              title: "Não foi possível realizar o pagamento",
              text: this.retornaMensagemErro400(
                error.response.data.details[0].error_code
              ),
              type: "error",
            });
          } else if (error.response.status === 402) {
            if (error.response.data.message === "DENY") {
              this.$fire({
                title: "Transação não aprovada",
                text: this.retornaMensagemAntifraude(
                  error.response.data.details[0].antifraud.status_code
                ),
                type: "error",
              });
            } else {
              this.$fire({
                title: "Transação não aprovada",
                text: this.retornaMensagemErro402(
                  error.response.data.details[0].error_code
                ),
                type: "error",
              });
            }
          }
        });
    },
    limparCartaoCredito() {
      this.cartaoCreditoModel = {
        nomeCartao: null,
        mesVencimento: null,
        anoVencimento: null,
        codSeguranca: null,
        cpf: this.$store.state.usuario.usuario.Cpf,
        numeroCartao: null,
      };
    },
    limparCartaoDebito() {
      this.cartaoDebitoModel = {
        nomeCartao: null,
        mesVencimento: null,
        anoVencimento: null,
        codSeguranca: null,
        cpf: this.$store.state.usuario.usuario.Cpf,
        numeroCartao: null,
      };
    },
    opcaoCartaoCredito() {
      if (this.$store.state.carrinho.idCarrinho != null) {
        this.limparCartaoDebito();
        this.cartaoCredito(true);
        this.cartaoDebito(false);
        this.picPay(false);
      } else {
        this.$fire({
          title: "O prazo para concluir a sua compra expirou",
          type: "warning",
        }).then((r) => {
          this.$router.push({ name: "HomePage" });
        });
      }
    },
    opcaoCartaoDebito() {
      if (this.$store.state.carrinho.idCarrinho != null) {
        this.limparCartaoCredito();
        this.cartaoDebito(true);
        this.cartaoCredito(false);
        this.picPay(false);
      } else {
        this.$fire({
          title: "O prazo para concluir a sua compra expirou",
          type: "warning",
        }).then((r) => {
          this.$router.push({ name: "HomePage" });
        });
      }
    },
    async opcaoPicPay() {
      if (this.$store.state.carrinho.idCarrinho != null) {
        this.limparCartaoCredito();
        this.limparCartaoDebito();
        this.cartaoDebito(false);
        this.cartaoCredito(false);
        this.picPay(true);
        if (
          this.$store.state.finalizarCompra.qrCodePicPay == null &&
          this.$store.state.finalizarCompra.urlPicPay == null
        ) {
          await this.defineCodigoPedido();
          if (
            this.$store.state.usuario.usuario.Cpf != null &&
            this.$store.state.usuario.usuario.Telefone != null
          ) {
            this.loading(true);
            axios({
              method: "post",
              url: "https://appws.picpay.com/ecommerce/public/payments",
              data: {
                referenceId:
                  this.$store.state.finalizarCompra.idPedido.toString(),
                callbackUrl:
                  "https://us-central1-loja-ilha-teste.cloudfunctions.net/requisicoes/callback",
                value: this.$store.state.carrinho.total,
                expiresAt: this.dataExpiracao,
                buyer: {
                  firstName: this.$store.state.usuario.usuario.PrimeiroNome,
                  lastName: this.$store.state.usuario.usuario.UltimoNome,
                  document: this.$store.state.usuario.usuario.Cpf.replace(
                    /\./g,
                    ""
                  ).replace("-", ""),
                  email: this.$store.state.usuario.usuario.Email,
                  phone:
                    "+55" +
                    this.$store.state.usuario.usuario.Telefone.replace("(", "")
                      .replace(")", "")
                      .replace(" ", "")
                      .replace("-", ""),
                },
              },
              headers: {
                "x-picpay-token": "04339499-44a7-4527-bc6c-c3dda898bc3c",
                "x-seller-token": "33aab1cb-d87c-498d-aed5-2919cbd32d0f",
              },
            })
              .then(async (response) => {
                this.qrCodePicPay(response.data.qrcode.base64);
                this.urlPicPay(response.data.paymentUrl);
                await db
                  .collection("Pagamentos")
                  .doc(
                    this.$store.state.finalizarCompra.idPedido
                      .toString()
                      .padStart(14, "0")
                  )
                  .set({
                    CodigoPedido: this.$store.state.finalizarCompra.idPedido
                      .toString()
                      .padStart(14, "0"),
                    IdCliente: this.$store.state.usuario.usuario.id,
                    NomeCliente: this.$store.state.usuario.usuario.NomeCompleto,
                    EmailCliente: this.$store.state.usuario.usuario.Email,
                    DocumentoCliente: this.$store.state.usuario.usuario.Cpf,
                    TelefoneCliente: this.$store.state.usuario.usuario.Telefone,
                    DataHoraPedido: Timestamp.now(),
                    PagamentoInfo: response.data,
                    Total: this.$store.state.carrinho.total,
                    Promocoes: this.produtosCarrinho,
                    FormaPgto: "PicPay",
                    StatusPagamento: "Pendente Pagamento",
                    StatusOperadora: "created",
                    IdCarrinho: this.$store.state.carrinho.idCarrinho,
                  });
                if (this.$store.state.carrinho.dadosCupomDesconto != null) {
                  await cupom.executaFuncoesCupom();
                }
                this.loading(false);
                this.finalizarPagamento("created", response.data, "PicPay");
              })
              .catch((error) => {
                this.loading(false);
                if (error.response.status === 422) {
                  if (
                    error.response.data.message.includes(
                      "Já existe referenceId"
                    )
                  ) {
                    this.$fire({
                      title: error.response.data.message,
                      text: "Error interno, Id da compra inválido",
                      type: "error",
                    });
                  } else {
                    this.$fire({
                      title: "Não foi possível efetuar a compra",
                      text: this.retornaMensagemErro(
                        error.response.data.errors[0].field
                      ),
                      type: "error",
                    });
                  }
                } else if (error.response.status === 401) {
                  this.$fire({
                    title: error.response.data.message,
                    text: this.retornaMensagemErro(401),
                    type: "error",
                  });
                } else if (error.response.status === 500) {
                  this.$fire({
                    title: error.response.data.message,
                    text: this.retornaMensagemErro(500),
                    type: "error",
                  });
                }
              });
          } else if (this.$store.state.usuario.usuario.Cpf == null) {
            this.$prompt(
              "Para continuar, precisamos que você nos informe o seu CPF"
            ).then((text) => {
              var usuario = this.$store.state.usuario.usuario;
              usuario.Cpf = text;
              this.usuarioAtual(usuario);
              db.collection("Clientes")
                .doc(this.$store.state.usuario.usuario.Email)
                .update({
                  Cpf: text,
                });
              this.opcaoPicPay();
            });
          } else if (this.$store.state.usuario.usuario.Telefone == null) {
            this.$prompt(
              "Para continuar, precisamos que você nos informe o seu Telefone"
            ).then((text) => {
              var usuario = this.$store.state.usuario.usuario;
              usuario.Telefone = text;
              this.usuarioAtual(usuario);
              db.collection("Clientes")
                .doc(this.$store.state.usuario.usuario.Email)
                .update({
                  Telefone: text,
                });
              this.opcaoPicPay();
            });
          }
        }
      } else {
        this.loading(false);
        this.$fire({
          title: "O prazo para concluir a sua compra expirou",
          type: "warning",
        }).then((r) => {
          this.$router.push({ name: "HomePage" });
        });
      }
    },
    async gravarRespostasPagamentoNaoConcluido(infoPagamento, formaPagamento) {
      var codigoPedido = this.$store.state.finalizarCompra.idPedido
        .toString()
        .padStart(14, "0");
      await db
        .collection("Pagamentos")
        .doc(
          this.$store.state.finalizarCompra.idPedido
            .toString()
            .padStart(14, "0")
        )
        .get()
        .then((doc) => {
          if (doc.exists) {
            var tamanho = 1;
            var characters =
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
            var result = "";
            for (var i = 0; i < tamanho; i++) {
              result +=
                characters[Math.floor(Math.random() * characters.length)];
            }
            codigoPedido =
              this.$store.state.finalizarCompra.idPedido
                .toString()
                .padStart(13, "0") + result;
          }
        });
      await db
        .collection("Pagamentos")
        .doc(codigoPedido)
        .set({
          CodigoPedido: this.$store.state.finalizarCompra.idPedido
            .toString()
            .padStart(14, "0"),
          IdCliente: this.$store.state.usuario.usuario.id,
          NomeCliente: this.$store.state.usuario.usuario.NomeCompleto,
          EmailCliente: this.$store.state.usuario.usuario.Email,
          DocumentoCliente: this.$store.state.usuario.usuario.Cpf,
          TelefoneCliente: this.$store.state.usuario.usuario.Telefone,
          DataHoraPedido: Timestamp.now(),
          PagamentoInfo: infoPagamento,
          Total: this.$store.state.carrinho.total,
          Promocoes: this.produtosCarrinho,
          FormaPgto: formaPagamento,
          StatusPagamento: "Pendente",
          StatusOperadora: "CREATED",
          IdCarrinho: this.$store.state.carrinho.idCarrinho,
        });
      this.loading(false);
      this.$fire({
        title: "Pendente confirmação de pagamento",
        text: "Sua transação foi registrada, mas o pagamento ainda não foi confirmado pela sua operadora de crédito. Você receberá um e-mail com a confirmação de sua compra assim que a transação for concluída.",
        type: "info",
      });
    },
    async gravarPagamentoErro(infoPagamento, formaPagamento) {
      var codigoPedido = this.$store.state.finalizarCompra.idPedido
        .toString()
        .padStart(14, "0");
      await db
        .collection("Pagamentos")
        .doc(
          this.$store.state.finalizarCompra.idPedido
            .toString()
            .padStart(14, "0")
        )
        .get()
        .then((doc) => {
          if (doc.exists) {
            var tamanho = 1;
            var characters =
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
            var result = "";
            for (var i = 0; i < tamanho; i++) {
              result +=
                characters[Math.floor(Math.random() * characters.length)];
            }
            codigoPedido =
              this.$store.state.finalizarCompra.idPedido
                .toString()
                .padStart(13, "0") + result;
          }
        });
      await db
        .collection("Pagamentos")
        .doc(codigoPedido)
        .set({
          CodigoPedido: this.$store.state.finalizarCompra.idPedido
            .toString()
            .padStart(14, "0"),
          IdCliente: this.$store.state.usuario.usuario.id,
          NomeCliente: this.$store.state.usuario.usuario.NomeCompleto,
          EmailCliente: this.$store.state.usuario.usuario.Email,
          DocumentoCliente: this.$store.state.usuario.usuario.Cpf,
          TelefoneCliente: this.$store.state.usuario.usuario.Telefone,
          DataHoraPedido: Timestamp.now(),
          PagamentoInfo: infoPagamento,
          Total: this.$store.state.carrinho.total,
          Promocoes: this.produtosCarrinho,
          FormaPgto: formaPagamento,
          StatusPagamento: "Recusado",
          StatusOperadora: "DENIED",
          IdCarrinho: this.$store.state.carrinho.idCarrinho,
        });
    },
    async finalizarPagamento(statusPagamento, infoPagamento, formaPagamento) {
      var codigoPedido = this.$store.state.finalizarCompra.idPedido
        .toString()
        .padStart(14, "0");
      await db
        .collection("Pagamentos")
        .doc(
          this.$store.state.finalizarCompra.idPedido
            .toString()
            .padStart(14, "0")
        )
        .get()
        .then((doc) => {
          if (doc.exists) {
            var tamanho = 1;
            var characters =
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
            var result = "";
            for (var i = 0; i < tamanho; i++) {
              result +=
                characters[Math.floor(Math.random() * characters.length)];
            }
            codigoPedido =
              this.$store.state.finalizarCompra.idPedido
                .toString()
                .padStart(13, "0") + result;
          }
        });
      if (formaPagamento !== "PicPay") {
        await db
          .collection("Pagamentos")
          .doc(codigoPedido)
          .set({
            CodigoPedido: this.$store.state.finalizarCompra.idPedido
              .toString()
              .padStart(14, "0"),
            IdCliente: this.$store.state.usuario.usuario.id,
            NomeCliente: this.$store.state.usuario.usuario.NomeCompleto,
            EmailCliente: this.$store.state.usuario.usuario.Email,
            DocumentoCliente: this.$store.state.usuario.usuario.Cpf,
            TelefoneCliente: this.$store.state.usuario.usuario.Telefone,
            DataHoraPedido: Timestamp.now(),
            PagamentoInfo: infoPagamento,
            Total: this.$store.state.carrinho.total,
            Promocoes: this.produtosCarrinho,
            FormaPgto: formaPagamento,
            StatusPagamento: "Pagamento Realizado",
            StatusOperadora: "APPROVED",
            IdCarrinho: this.$store.state.carrinho.idCarrinho,
          });
        await db
          .collection("Clientes")
          .doc(this.$store.state.usuario.usuario.Email)
          .collection("Pagamentos")
          .doc(codigoPedido)
          .set({
            CodigoPedido: this.$store.state.finalizarCompra.idPedido
              .toString()
              .padStart(14, "0"),
            DataHoraPedido: Timestamp.now(),
            Total: this.$store.state.carrinho.total,
            Promocoes: this.produtosCarrinho,
            StatusPagamento: "Pagamento Realizado",
            StatusOperadora: "APPROVED",
            PagamentoInfo: infoPagamento,
            FormaPgto: formaPagamento,
            IdCarrinho: this.$store.state.carrinho.idCarrinho,
          });
        if (this.$store.state.carrinho.dadosCupomDesconto != null) {
          await cupom.executaFuncoesCupom();
        }
      }
      if (formaPagamento !== "PicPay") {
        this.loading(false);
        this.$fire({
          title: "Compra efetuada com sucesso!",
          type: "success",
        }).then((r) => {
          this.loading(true);
          this.finalizarPagamentoCompras(statusPagamento, formaPagamento);
        });
      } else {
        db.collection("Pagamentos")
          .doc(
            this.$store.state.finalizarCompra.idPedido
              .toString()
              .padStart(14, "0")
          )
          .onSnapshot(async (doc) => {
            if (doc.data().StatusOperadora === "expired") {
              this.loading(false);
              this.$alert("O prazo para conclusão da sua compra expirou");
              this.$router.push({ name: "HomePage" });
            } else if (doc.data().StatusOperadora === "analysis") {
              this.loading(false);
              this.$confirm("O pagamento foi recusado pelo PicPay").then(() => {
                this.picPay(false);
                this.cartaoDebito(false);
                this.cartaoCredito(false);
              });
            } else if (doc.data().StatusOperadora === "paid") {
              this.pagamentoConcluido(true);
              this.loading(false);
              this.$fire({
                title: "Compra efetuada com sucesso!",
                type: "success",
              }).then((r) => {
                this.loading(true);
                this.finalizarPagamentoCompras(statusPagamento, formaPagamento);
              });
            } else if (doc.data().StatusOperadora === "refunded") {
              this.loading(false);
              this.$fire({
                title: "Compra não pôde ser efetuada",
                type: "error",
              }).then((r) => {
                this.$router.push({ name: "HomePage" });
              });
            }
          });
      }
    },
    async finalizarPagamentoCompras(statusPagamento, formaPagamento) {
      if (formaPagamento !== "PicPay") {
        for (var i in this.produtosCarrinho) {
          await db
            .collection("Promocoes")
            .doc(this.produtosCarrinho[i].id.substring(0, 20))
            .get()
            .then(async (doc) => {
              var mapa = doc.data().QtdUnidades;
              mapa[this.produtosCarrinho[i].Unidade] =
                doc.data().QtdUnidades[this.produtosCarrinho[i].Unidade] -
                this.produtosCarrinho[i].Quantidade;
              await db
                .collection("Promocoes")
                .doc(this.produtosCarrinho[i].id.substring(0, 20))
                .update({
                  QtdUnidades: mapa,
                });
            });
          const dadosCompras = {
            CodigoPedido: this.$store.state.finalizarCompra.idPedido
              .toString()
              .padStart(14, "0"),
            IdCliente: this.$store.state.usuario.usuario.id,
            NomeCliente: this.$store.state.usuario.usuario.NomeCompleto,
            TelefoneCliente: this.$store.state.usuario.usuario.Telefone,
            EmailCliente: this.$store.state.usuario.usuario.Email,
            DataHoraPedido: Timestamp.now(),
            ProdutoTitulo: this.produtosCarrinho[i].ProdutoTitulo,
            ProdutoUrlImagens: this.produtosCarrinho[i].Imagem,
            PrecoPromocional: this.produtosCarrinho[i].ValorUnitario,
            DataPromocao: new Timestamp(
              this.produtosCarrinho[i].DataOk.seconds,
              this.produtosCarrinho[i].DataOk.nanoseconds
            ),
            Quantidade: 1,
            Unidade: this.produtosCarrinho[i].Unidade,
            Horario: this.produtosCarrinho[i].Horario,
            StatusPromocao: "Não consumida",
            FormaPgto: formaPagamento,
            IdPromocao: this.produtosCarrinho[i].id.substring(0, 20).trim(),
            SemData: this.produtosCarrinho[i].SemData,
          };
          for (var y = 0; y < this.produtosCarrinho[i].Quantidade; y++) {
            var dataPromocaoFormatada = new Date(
              dadosCompras.DataPromocao.toDate().toISOString()
            );
            this.htmlPromocoes +=
              '<div style="border-bottom: 1px solid #f3f3f3; margin: 10px auto; width: 70%; max-width: 400px; display: grid; text-align: center">' +
              '<img style="margin: 5px auto; width: 70%; max-width: 360px" src="' +
              dadosCompras.ProdutoUrlImagens +
              '">' +
              '<p style="font-size: 18px; font-bold: 600">' +
              dadosCompras.ProdutoTitulo +
              "</p>" +
              '<div style="margin: 0 auto; padding: 0 10px; width: 100%; display: flex; justify-content: center; gap: 20px; color: #00f">';
            this.htmlPromocoes +=
              dadosCompras.SemData === false
                ? '<span style="width: 30%; max-width: 120px; text-align: center">' +
                  dataPromocaoFormatada.getDate().toString().padStart(2, "0") +
                  "/" +
                  dataPromocaoFormatada.getMonth() +
                  "/" +
                  dataPromocaoFormatada.getFullYear() +
                  " </span>"
                : '<span style="width: 30%; max-width: 120px; text-align: center">Qualquer data</span>';
            this.htmlPromocoes +=
              '<span style="width: 30%; max-width: 120px; text-align: center">' +
              dadosCompras.Horario +
              "</span>" +
              '<span style="width: 30%; max-width: 120px; font-weight: 600; text-align: center">' +
              dadosCompras.Unidade +
              "</span></div>";
            await db
              .collection("Compras")
              .add(dadosCompras)
              .then(async (docRef) => {
                this.htmlPromocoes +=
                  '<div style="padding: 20px 0px"><img src="' +
                  "https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=" +
                  docRef.id +
                  dadosCompras.IdCliente +
                  '"/></div></div>' +
                  '<br><hr style="color: #f3f3f3"><br>';
                await db
                  .collection("Clientes")
                  .doc(this.$store.state.usuario.usuario.Email)
                  .collection("Compras")
                  .doc(docRef.id)
                  .set(dadosCompras)
                  .then((docRef) => {
                    this.pagamentoConcluido(true);
                  });
              });
          }
        }
        this.enviarEmail();
        db.collection("Carrinho")
          .doc(this.$store.state.carrinho.idCarrinho)
          .delete();
        this.destroiCupom();
        this.loading(false);
        this.$router.push({
          name: "Conclusao",
          params: {
            id: this.$store.state.finalizarCompra.idPedido
              .toString()
              .padStart(14, "0"),
          },
        });
      } else {
        this.saindoPagamentoConcluido = true;
        this.loading(false);
        this.$router.push({
          name: "Conclusao",
          params: {
            id: this.$store.state.finalizarCompra.idPedido
              .toString()
              .padStart(14, "0"),
          },
        });
      }
    },
    enviarEmail() {
      axios({
        method: "post",
        url: "https://us-central1-loja-ilha-teste.cloudfunctions.net/email",
        data: {
          EmailCliente: this.$store.state.usuario.usuario.Email,
          CodigoPedido: this.$store.state.finalizarCompra.idPedido
            .toString()
            .padStart(14, "0"),
          Promocoes: this.htmlPromocoes,
          NomeCliente: this.$store.state.usuario.usuario.NomeCompleto,
        },
      });
    },
  },
};
</script>

<style scoped>
.content,
.content2 {
  max-width: 1174px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  grid-template-areas:
    "etapas"
    "etapas-titulo"
    "pagamento";
}

.content {
  padding: 40px;
}

.content2 {
  padding: 40px 150px 40px 0;
}

@media (max-width: 1000px) {
  .content2 {
    margin: 0;
    padding: 20px 10px;
    grid-template-columns: 100%;
  }
}

/* Carrinho footer */
.carrinho-top {
  grid-area: carrinho-top;
}

/* login */
.pagamento2 {
  grid-area: pagamento;
  background: #fff;
  box-shadow: 5px 5px 15px 0px rgba(44, 44, 44, 0.15);
  padding: 10px 10px 25px 10px;
  width: 70%;
  justify-self: center;
}

.pagamento {
  grid-area: pagamento;
  background: #fff;
  box-shadow: 5px 5px 15px 0px rgba(44, 44, 44, 0.15);
  padding: 10px 10px 25px 10px;
  width: 50%;
  justify-self: center;
}

.titulo {
  font-size: 1.2rem;
  color: #2e9189;
  font-weight: 600;
  border-bottom: 1px solid #2e9189;
  padding: 5px 0;
  margin: 0 0 15px 0;
}

.forma-pgto {
  display: flex;
  justify-content: space-around;
}

.forma-pgto div {
  width: 30%;
  padding: 10px 5px;
  margin: 20px 0;
  align-self: center;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.credito,
.debito,
.picpay {
  background: #f3f3f3;
  display: grid;
  grid-template-columns: 20px auto;
  align-self: center;
  align-items: center;
  height: 62px;
}

.ativo {
  background: #2e9189;
  color: #ffffff;
}

.forma-pgto div:hover {
  background: #2e9189;
  color: #ffffff;
}

.forma-pgto span {
  padding: 0 0 0 10px;
}

.logo-cartao {
  position: absolute;
  right: 60px;
  top: 27px;
  z-index: 999;
}

/* Formulário pagamento */
.formulario-pgto {
  margin: 20px 0 0 0;
  transition: all 0.3s ease;
}

.formulario-ok2 {
  width: 90%;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
  width: 95%;
  display: grid;
  justify-items: start;
  align-items: start;
  margin: 0 auto 30px auto;
}

.formulario-ok {
  width: 90%;
  grid-template-columns: 1fr;
  gap: 25px;
  width: 95%;
  display: grid;
  justify-items: start;
  align-items: start;
  margin: 0 auto 30px auto;
}

.formulario-ok img,
.formulario-ok2 img {
  margin: 8px 0 0 0;
}

.form-left {
  display: grid;
  width: 100%;
}

.form-left span,
.form-right span {
  text-align: left;
}

.form-right {
  display: grid;
  width: 100%;
}

.validade {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.validade span {
  text-align: left;
  grid-column: span 2;
}

.dica {
  font-size: 0.7rem;
}

.picpay-div {
  align-self: center;
  height: 80%;
  margin: 0 auto 0 auto;
  cursor: pointer;
}

.picpay-link {
  color: #21c25e;
  text-align: center;
  font-weight: 500;
  font-size: 1.1em;
  margin: 0 auto;
  display: none;
  cursor: pointer;
}

.picpay-div img {
  max-width: 380px;
  width: 75%;
  margin: 0 auto;
}

.picpay-mensagem {
  text-align: center;
}

.picpay-div2 {
  display: grid;
  grid-template-columns: 30px auto;
  gap: 20px;
  margin: 20px 10% 0 10%;
  padding: 20px;
  border-radius: 4px;
  background: #f3f3f3;
}

.icone-ampulheta {
  width: 20px;
  height: 20px;
  align-self: center;
}

.picpay-mensagem2 {
  text-align: left;
  color: #21c25e;
  font-weight: 500;
  font-size: 0.95rem;
}

button {
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  border: 0;
  font-size: 1.05em;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.2);
  transition: all 0.3s;
}

button:hover {
  transform: scale(1.1);
}

.bt-login {
  background: #2e9189;
}
.select-ano {
  width: 90px;
}

.select-cpf {
  width: 70%;
}

.select-codigo {
  width: 90px;
}

.bt-login:hover {
  background: #186b65;
}

@media (max-width: 960px) {
  .pagamento {
    padding: 10px 2px 25px 2px;
    width: 98%;
  }
  .formulario-ok {
    width: 90%;
    grid-template-columns: 1fr;
    gap: 25px;
  }
  .picpay-mensagem2 {
    font-weight: 400;
    padding: 16px 0;
  }
  .picpay-link {
    display: block;
  }
}

@media (max-width: 660px) {
  .pagamento {
    width: 98%;
    padding: 0 2px 25px 2px;
  }
  .credito,
  .debito,
  .picpay {
    grid-template-columns: 1fr;
    height: 85px;
  }
  .forma-pgto span {
    padding: 5px 0 0 0;
  }
  .picpay-div h3 {
    color: #21c25e;
  }
  .picpay-div2 {
    margin: 20px 5px;
    padding: 2px 10px 2px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Pagamento.vue